import { render, staticRenderFns } from "./BranchesManagement.vue?vue&type=template&id=7d613ac2&scoped=true"
import script from "./BranchesManagement.vue?vue&type=script&lang=js"
export * from "./BranchesManagement.vue?vue&type=script&lang=js"
import style0 from "./BranchesManagement.vue?vue&type=style&index=0&id=7d613ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d613ac2",
  null
  
)

export default component.exports